import { useQuery } from 'react-query';
import { InterviewTemplateService } from '../../../services/v1/applicant_tracking/InterviewTemplateService';

export const useInterviewTemplates = () => {
  return useQuery({
    queryKey: ['interview_templates'],
    queryFn: async () => await InterviewTemplateService.list(),
  });
};
